<template>
  <div>
    <WhatsappEditar :exame="formData" :showForm="showFormEdit" :parent="this" />
    <WhatsappTeste :exame="formData" :showForm="showFormTeste" :parent="this" />

    <TableView
      registerName="Inserir Conta WhatsApp"
      :onRegister="tableData.length > 0 ? null : onRegister"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :onSearch="getContaWhatsapp"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
    ></TableView>
  </div>
</template>

<script>
import TableView from "common/table";
import Rest from "common/rest";
import WhatsappEditar from "./editar";
import WhatsappTeste from "./teste";

export default {
  name: "conta-whatsapp",
  components: { TableView, WhatsappEditar, WhatsappTeste },
  mixins: [Rest],
  data() {
    return {
      formData: {
        id: 0,
        nome: null,
        phone_number_id: null,
        business_account_id: null,
        access_token: null
      },
      pagination: {},
      response: {},
      tableHead: [
        {
          key: "nome",
          sortable: true,
          label: "Nome"
        },
        {
          key: "phone_number_id",
          sortable: true,
          label: "Phone Number ID"
        },
        {
          key: "business_account_id",
          sortable: true,
          label: "Business Account ID"
        }
      ],
      tableData: [],
      loadingTable: false,
      showFormEdit: false,
      showFormTeste: false
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },

  created() {
    var clienteId = this.cliente && this.cliente.logged ? this.cliente.logged.id : null;
    if (clienteId !== 1 && clienteId !== 914) {
      this.$router.replace('/');
      return;
    }
  },

  mounted: function() {
    this.getContaWhatsapp();
  },

  methods: {
    onRegister: function() {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: 0,
        nome: null,
        phone_number_id: null,
        business_account_id: null,
        access_token: null
      };
    },

    onEdit: function(data) {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: data.id,
        nome: data.nome,
        phone_number_id: data.phone_number_id,
        business_account_id: data.business_account_id,
        access_token: null
      };
    },

    onDelete: function(data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      ).then(() => {
        self.loadingTable = true;

        this.post("/conta-whatsapp/deletar", { ids: data }).then(result => {
          result = result[0];
          self.loadingTable = false;

          if (result.status == 200) {
            self.getContaWhatsapp();
            self.edMsg("Registro excluído com sucesso");
          }
        });
      });
    },

    onTest(data) {
      this.showFormTeste = !this.showFormTeste;
      this.formData = {
        id: data.id,
        nome: data.nome
      };
    },

    getContaWhatsapp: function(_search, _page, _pagination) {
      this.loadingTable = true;
      this.response = {};

      this.get("conta-whatsapp", {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(result => {
        result = result[0];
        this.response = result;

        if (result.status == 200) {
          var data = result.data.data,
            tableData = [],
            pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              phone_number_id: data[i].phone_number_id,
              business_account_id: data[i].business_account_id,
              _data: data[i],
              options: {
                disable_delete: !this.validarPermissao(592),
                disable_edit: !this.validarPermissao(592)
              },
              buttons: [
                {
                  icon: "fa fa-check",
                  color: "success",
                  title: "Enviar WhatsApp Teste",
                  click: this.onTest
                }
              ]
            };

            tableData.push(item);
          }

          this.pagination = pagination;
          this.tableData = tableData;
          this.loadingTable = false;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?110fd111